(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationDialogController', PublicSiteTranslationDialogController);

    PublicSiteTranslationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteTranslation', 'PublicSitePartRelationship', 'PublicSitePartKey', 'PublicSiteLanguage'];

    function PublicSiteTranslationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteTranslation, PublicSitePartRelationship, PublicSitePartKey, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteTranslation = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsitepartrelationships = PublicSitePartRelationship.query();
        vm.publicsitepartkeys = PublicSitePartKey.query();
        vm.publicsitelanguages = PublicSiteLanguage.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteTranslation.id !== null) {
                PublicSiteTranslation.update(vm.publicSiteTranslation, onSaveSuccess, onSaveError);
            } else {
                PublicSiteTranslation.save(vm.publicSiteTranslation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteTranslationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
